import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[anwsersDirectiveHost]',
})
export class AnwsersDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
